import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './SubscriptionHistory.module.scss';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';

const ACTION_LABELS = {
  CREATED: { label: 'Created', className: 'actionCreated' },
  UPDATED: { label: 'Updated', className: 'actionUpdated' },
  DEACTIVATED: { label: 'Deactivated', className: 'actionDeactivated' },
  ACTIVATED: { label: 'Activated', className: 'actionActivated' },
};

const SubscriptionHistory = ({ subscriptionId }) => {
  const { showToast } = useToasts();
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!subscriptionId) return;
    const fetchHistory = async () => {
      setIsLoading(true);
      try {
        const response = await axiosClient.get(`/subscription/${subscriptionId}/history`);
        setHistory(response.data?.history || []);
      } catch (error) {
        showToast(error.message || 'Failed to fetch history', 'error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchHistory();
  }, [subscriptionId, showToast]);

  return (
    <div className={styles.container}>
      {isLoading && <LoadingOverlay />}
      <h2 className={styles.title}>History</h2>
      {history.length > 0 ? (
        <div className={styles.timeline}>
          {history.map((entry) => {
            const action = ACTION_LABELS[entry.action] || { label: entry.action, className: 'actionUpdated' };
            return (
              <div key={entry.id} className={styles.entry}>
                <div className={styles.dot} />
                <div className={styles.content}>
                  <div className={styles.row}>
                    <span className={`${styles.action} ${styles[action.className]}`}>
                      {action.label}
                    </span>
                    <span className={styles.user}>
                      {entry.changedBy?.firstName} {entry.changedBy?.lastName}
                    </span>
                  </div>
                  <span className={styles.date}>
                    {new Date(entry.createdAt).toLocaleString()}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        !isLoading && <p className={styles.empty}>No history available.</p>
      )}
    </div>
  );
};

SubscriptionHistory.propTypes = {
  subscriptionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SubscriptionHistory;
